import React from 'react'
import styles from './index.scss'

interface AppHeaderProps {}

const AppHeader: React.SFC<AppHeaderProps> = ({ children }) => {
  return (
    <div className={styles.appHeader}>
      <div className={styles.appHeaderInner}>{children}</div>
    </div>
  )
}

export default AppHeader
